import React, { useState, useEffect } from 'react';
import axios from '../../axios';
import { Table, Container, Button, Modal, Form, Pagination } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import UploadForm from './UploadForm'; // Import UploadForm

const StudentList = () => {
  const [students, setStudents] = useState([]);
  const [search, setSearch] = useState('');
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [showUploadModal, setShowUploadModal] = useState(false); // State để quản lý hiển thị modal
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false); // Modal để xác nhận xóa tất cả sinh viên

  useEffect(() => {
    fetchData();
  }, [page, search]);

  const fetchData = async () => {
    const res = await axios.get('/students', {
      headers: { 'x-auth-token': localStorage.getItem('token') },
      params: { page, search }
    });
    setStudents(res.data.students);
    setTotalPages(res.data.pages);
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setPage(1);
    fetchData();
  };

  const handleShowUploadModal = () => {
    setShowUploadModal(true);
  };

  const handleCloseUploadModal = () => {
    setShowUploadModal(false);
  };

  const handleShowDeleteConfirmModal = () => {
    setShowDeleteConfirmModal(true);
  };

  const handleCloseDeleteConfirmModal = () => {
    setShowDeleteConfirmModal(false);
  };

  const handleDeleteAllStudents = async () => {
    try {
      await axios.delete('/students/delete-all', {
        headers: { 'x-auth-token': localStorage.getItem('token') },
      });
      fetchData(); // Refresh the list after deletion
      handleCloseDeleteConfirmModal(); // Close the modal
    } catch (err) {
      console.error(err);
    }
  };

  const handlePageChange = (pageNumber) => {
    setPage(pageNumber);
  };

  return (
    <Container>
      <h2>Student List</h2>
      <Form inline onSubmit={handleSearchSubmit} className="mb-3">
        <Form.Control
          type="text"
          placeholder="Search by name, major code or exam number"
          value={search}
          onChange={handleSearchChange}
          className="mr-sm-2"
        />
        <Button variant="primary" type="submit">Tìm</Button>
      </Form>
      <Button variant="primary" className="mb-3" onClick={handleShowUploadModal}>
        Upload Students
      </Button>
      <Button variant="danger" className="mb-3 ml-2" onClick={handleShowDeleteConfirmModal}>
        Delete All Students
      </Button>
      <Link to="/add-student">
        <Button variant="primary" className="mb-3 ml-2">Add Student</Button>
      </Link>
      <Table striped bordered hover>
        <thead>
          <tr>
          <th>Số thứ tự</th> {/* Cột Số thứ tự */}
            <th>Student ID</th>
            <th>Exam Number</th>
            <th>Name</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {students.map((student, index) => (
            <tr key={student._id}>
              <td>{(page - 1) * 20 + index + 1}</td> {/* Tính số thứ tự */}
              <td>{student.studentId}</td>
              <td>{student.examNumber}</td>
              <td>{student.name}</td>
              <td>
                <Link to={`/edit-student/${student._id}`}>
                  <Button variant="warning" className="mr-2">Edit</Button>
                </Link>
                {/* Button to delete the student can be added here */}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>

      {/* Pagination */}
      <Pagination>
        {[...Array(totalPages).keys()].map(number => (
          <Pagination.Item key={number + 1} active={number + 1 === page} onClick={() => handlePageChange(number + 1)}>
            {number + 1}
          </Pagination.Item>
        ))}
      </Pagination>

      {/* Modal để hiển thị UploadForm */}
      <Modal show={showUploadModal} onHide={handleCloseUploadModal}>
        <Modal.Header closeButton>
          <Modal.Title>Import Students from Excel</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <UploadForm onUploadSuccess={handleCloseUploadModal} /> {/* Truyền prop onUploadSuccess */}
        </Modal.Body>
      </Modal>

      {/* Modal để xác nhận xóa tất cả sinh viên */}
      <Modal show={showDeleteConfirmModal} onHide={handleCloseDeleteConfirmModal}>
        <Modal.Header closeButton>
          <Modal.Title>Xác nhận xóa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Bạn có chắc chắn muốn xóa tất cả sinh viên không? Hành động này không thể hoàn tác.
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDeleteConfirmModal}>
            Hủy
          </Button>
          <Button variant="danger" onClick={handleDeleteAllStudents}>
            Xóa tất cả
          </Button>
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default StudentList;
